<template>
  <div style="scrollbar-gutter: stable">
    <slot name="title" />
    <filter-display
      v-bind="{ filters, filtersQuery, currency }"
      class="b-b b-grey-80 p-3"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
    />
    <vf-accordion
      v-if="sortOptions?.length"
      class="b-t-0"
      open
      size="md"
      :title="$t.sort"
    >
      <div class="f-col gap-3 pb-4">
        <vf-radio
          v-for="{ value, label } in sortOptions"
          :key="value"
          :model-value="sortState"
          name="sort"
          :value
          @update:model-value="$emit('sort', $event!)"
        >
          {{ label }}
        </vf-radio>
      </div>
    </vf-accordion>
    <template v-if="Object.keys(filters)?.length">
      <vf-accordion
        v-for="(filter, code) in filters"
        :key="code"
        size="md"
        :title="filter.label"
      >
        <filter-options
          v-bind="{ filter, code }"
          class="pb-4"
          :currency
          :loading
          :model-value="filters[code].selected"
          @update:model-value="$emit('change', { code: `${code}`, selected: $event! })"
        />
      </vf-accordion>
    </template>
    <product-list-skeleton v-else-if="loading" />
  </div>
</template>

<script lang="ts" setup>
import type { SortType } from '#types/config/pages/plp'
import type { FiltersMap } from '#types/filters'

defineProps<{
  currency?: string
  loading?: boolean
  filters: FiltersMap
  filtersQuery?: Record<string, string[]>
  total: number
  sortOptions?: { value: SortType, label: string }[]
  sortState?: string
  storeFilterState?: string
}>()

defineEmits<{
  clear: []
  remove: [payload: { code: string, id: string }]
  change: [payload: { code: string, selected: string[] }]
  sort: [payload: string]
}>()

defineSlots<{
  title: () => void
}>()
</script>
